import styled from 'styled-components'
import { Theme, LinkIcon } from '@pga/pga-component-library'

export const ButtonBlue = styled.button`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  background-color: ${props => props.disabled ? Theme.colors.darkerLtGrey : Theme.colors.lightBlue};
  color: white;
  text-transform: uppercase;
  border: 0;
  padding: 15px 30px;
  font-family: ${Theme.fonts.Montserrat};
  font-size: 14px;
  transition: .3s;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  &:hover {
    text-decoration: none;
    color: white;
    background-color: ${Theme.colors.darkerLtGrey};
    border-color: ${Theme.colors.darkerLtGrey};
  }
  border: none;
`

export const ButtonOutline = styled(ButtonBlue)`
  background-color: transparent;
  padding: 8px 30px;
  color: ${Theme.colors.lightBlue};
  border: ${`1px solid ${Theme.colors.lightBlue}`};
`

export const Title = styled.h3`
  color: ${Theme.colors.primary};
  font-family: ${Theme.fonts.PlayfairDisplay};
  font-size: ${props => props.fs || '20px'};
  font-weight: ${props => props.fw || '600'};
`

export const Text = styled.p`
  color: ${(props) => props.color || Theme.colors.blueGrey};
  font-size: ${(props) => props.fs || `${props.size}px` || '12px'};
  font-family: ${Theme.fonts.Montserrat};
  font-weight: ${(props) => props.weight || props.fw || '500'};
  word-wrap: break-word;
  margin-top: ${(props) => `${props.mt}px`};
  margin-right: ${(props) => `${props.mr}px`};
  margin-bottom: ${(props) => `${props.mb}px`};
`

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  ${props => props.justifyContent && `justify-content: ${props.justifyContent}`};
  ${props => props.alignItems && `align-items: ${props.alignItems}`};
`

export const StyledLink = styled(LinkIcon)`
  padding-left: 6px;
`

export const LinkItemBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  background-color: ${Theme.colors.white};
  overflow: hidden;
  text-align: left;
  margin-left: 20px;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`
